import {
  ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT,
  ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT_SUCCESS,
  ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT_FAILURE,
} from '../configs/ActionTypes';

import * as _ from 'lodash-es';

const initialState = {
  value: null,
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        value: _.get(action.payload.payload, 'value', []),
        isLoading: false,
        success: null,
      };
    }

    case ACTION_GET_ACTIVE_EXPENSE_MANAGEMENT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    }

    default: {
      return state;
    }
  }
}
